module.exports = __webpack_public_path__ + "img/masteryIcon.3d02c1f7.png";